// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

// The project's public address: the custom domain (2026-10-05, Supabase
// custom-domain add-on), which is what a person ever sees of Supabase: on
// Google's consent screen, in auth links, in storage URLs. The project's own
// host (rpqhqhgxommztjozfmrg.supabase.co) keeps answering, so older builds
// and the webhooks registered on it keep working. One owner: nothing else in
// src/ spells either host (supabaseHost.parity).
export const SUPABASE_URL = "https://auth.contruly.app";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJwcWhxaGd4b21tenRqb3pmbXJnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTUxMjI2MDMsImV4cCI6MjA3MDY5ODYwM30.LCzOhGlPOW_4yplmjUjsIKnKjSXrOOy2Wwq7eyOMqvI";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

// The publishable (anon) key: public by design, in every browser bundle; the
// one other reader (ServiceIntelligence) imports it from here.
export { SUPABASE_PUBLISHABLE_KEY };

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
    // PKCE keeps OAuth tokens out of the URL hash/history. The SDK auto-exchanges
    // the ?code= it lands with on /dashboard because detectSessionInUrl is on.
    flowType: 'pkce',
    detectSessionInUrl: true,
    // Recovery codes for two-factor authentication (Settings → Security) are behind an
    // experimental switch in supabase-js 2.117; without it every call throws.
    experimental: { recoveryCodes: true },
  }
});